import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

const { borderRadius, colors, spacing, typography } = themeVariables;

/** Set per row as an inline style, so the bar's length is data rather than a class. */
export const BAR_WIDTH_VAR = '--rating-histogram-bar-width';

/** From the design; the theme has no size token for a meter. */
const BAR_HEIGHT = '3px';

/** Fixed, so every row's bar starts and ends on the same line whatever the counts. */
const STAR_COLUMN_WIDTH = '1.75rem';
const COUNT_COLUMN_WIDTH = '2.5rem';

export const rows = css`
  display: flex;
  flex-direction: column;
  row-gap: var(${spacing.xs});
  margin: 0;
  padding: 0;
  list-style: none;
  font-family: var(${typography.body.fontFamily});
  font-size: var(${typography.body.sizes.sm.fontSize});
  line-height: var(${typography.body.sizes.sm.lineHeight});
  color: var(${colors.content.default});
`;

export const row = css`
  display: grid;
  grid-template-columns: ${STAR_COLUMN_WIDTH} 1fr ${COUNT_COLUMN_WIDTH};
  align-items: center;
  column-gap: var(${spacing.sm});
`;

/* `700` is a literal: the theme has one body weight and no bold step. */
export const star = css`
  display: inline-flex;
  align-items: center;
  font-size: var(${typography.body.sizes.md.fontSize});
  font-weight: 700;
  line-height: var(${typography.body.sizes.md.lineHeight});
  font-variant-numeric: tabular-nums;
`;

export const track = css`
  overflow: hidden;
  height: ${BAR_HEIGHT};
  border-radius: var(${borderRadius.md.mobile});
  background-color: var(${colors.surface.brand});
`;

export const bar = css`
  display: block;
  width: var(${BAR_WIDTH_VAR});
  height: 100%;
  border-radius: var(${borderRadius.md.mobile});
  background-color: var(${colors.content.brand});
`;

export const count = css`
  font-variant-numeric: tabular-nums;
  text-align: right;
`;

export const empty = css`
  margin: 0;
  font-family: var(${typography.body.fontFamily});
  font-size: var(${typography.body.sizes.sm.fontSize});
  line-height: var(${typography.body.sizes.sm.lineHeight});
  color: var(${colors.content.secondary});
`;
